import { InputTheme } from '@kite-js/theme-types';

const input: InputTheme = {
    fontSize: 'M',
    paddingX: 'S',
    paddingY: 'L',
    borderRadius: 'S',
};

export default input;
